import { render, staticRenderFns } from "./SectorsUpdateForm.vue?vue&type=template&id=56a9e292&scoped=true"
import script from "./SectorsUpdateForm.vue?vue&type=script&lang=js"
export * from "./SectorsUpdateForm.vue?vue&type=script&lang=js"
import style0 from "./SectorsUpdateForm.vue?vue&type=style&index=0&id=56a9e292&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a9e292",
  null
  
)

export default component.exports